<template>
    <div class="catalog-layout">
        <catalog-filters :filters="filters"
                         @submited="onSubmit"
                         @reset="onReset">
        </catalog-filters>
        <div class="catalog-layout__content">
            <div class="catalog-layout__content_head">
                <div class="page-switcher">
                    <router-link to="/grid" class="active">Списком</router-link>
                    <router-link to="/map">На карте</router-link>
                    <span class="bg"></span>
                </div>
                <transition name="fade" duration="350">
                    <div class="numbers" v-if="sums.apartmentsCount > 0 & sums.buildingsCount > 0">
                        <div class="col">
                            <span>{{sums.apartmentsCount | threeDigits }}</span>
                            <small>
                                {{sums.apartmentsCount | apartmentsCount(true) }}
                                в&nbsp;продаже
                            </small>
                        </div>
                        <div class="col">
                            <span>{{sums.buildingsCount}}</span>
                            <small>
                                {{sums.buildingsCount | buildingsCount(true)}}
                            </small>
                        </div>
                    </div>
                </transition>
            </div>
            <keep-alive>
                <router-view :parent="parent"
                             :buildings="buildings"
                             :placemarks-data="placemarks"
                             :filters="filters"
                             @maps-opened="onMapsOpened"
                             @grid-opened="onGridOpened">
                </router-view>
            </keep-alive>
        </div>
        <transition name="fade" duration="350">
            <div class="page-spinner show" v-if="buildings.isLoading | placemarks.isLoading">
                <span style="background-image: url(/images/logo-blue.svg);"></span>
            </div>
        </transition>
    </div>
</template>

<script>
    // Libs
    import axios from 'axios';
    import cleanObject from './cleanObject';
    import qs from 'qs';

    // Components 
    import catalogGrid from './CatalogGrid.vue';
    import catalogMap from './CatalogMap.vue';
    import catalogFilters from './CatalogFilters.vue';
    import VueRouter from 'vue-router';

    // Filters
    import apartmentsCount from '../filters/apartmentsCount';
    import buildingsCount from '../filters/buildingsCount'
    import threeDigits from '../filters/threeDigits';

    const routerQueryFn = (route) => ({ query: route.query });

    const router =
        new VueRouter({
            mode: "history",
            base: "/catalog/",
            linkActiveClass: "active", // "router-link-active" by default
            routes: [
                {
                    path: "/",
                    redirect: { name: "grid" }
                },
                {
                    path: "/grid",
                    name: 'grid',
                    component: catalogGrid,
                    props: routerQueryFn
                },
                {
                    path: "/map",
                    name: 'map',
                    component: catalogMap,
                    props: routerQueryFn
                }
            ],
            parseQuery(query) {
                return qs.parse(query);
            },
            stringifyQuery(query) {
                let result = qs.stringify(cleanObject(query), {
                    skipNulls: true
                });
                return result ? ('?' + result) : '';
            }
        });

    // I have no idea how it works, but it works :)
    function hasQueryParams(route) {
        return !!Object.keys(route.query).length
    }

    // A hook to save a current route after component switched
    router.beforeEach((to, from, next) => {      
        if (!hasQueryParams(to) && hasQueryParams(from)) {
            next({ name: to.name, query: from.query });                        
        }
        else {
            next();
        }      
    });

    export default {
        props: ['parent', 'size'],
        components: {
            catalogGrid,
            catalogMap,
            catalogFilters
        },
        router,
        data() {
            return {
                buildings: {
                    list: [],
                    total: 0,
                    page: 0,
                    isLoading: false
                },
                placemarks: {
                    list: [],
                    isLoading: false
                },
                filters: {
                    metro: [],
                    districts: [],
                    roomTypes: [],
                    price: { minimum: null, maximum: null },
                    readinesses: [],
                    square: { minimum: null, maximum: null }
                },
                sums: {
                    apartmentsCount: 0,
                    buildingsCount: 0
                },
                orderBy: {}
            }
        },
        computed: {
            cleanFilters() {
                let formated = {
                    metro: this.filters.metro.map(item => item.station),
                    districts: this.filters.districts,
                    roomTypes: this.filters.roomTypes.map(range => { return { minimum: range.minimum, maximum: range.maximum } }),
                    price: this.filters.price,
                    readinesses: this.filters.readinesses,
                    square: this.filters.square
                };
                return cleanObject(formated);  
            },
            query() {
                return {
                    metro: this.filters.metro.map(item => item.station),
                    districts: this.filters.districts,
                    roomTypes: this.filters.roomTypes,
                    price: this.filters.price,
                    readinesses: this.filters.readinesses,
                    square: this.filters.square,
                    orderBy: this.orderBy
                };
            }
        },
        watch: {
            //query: {
            //    deep: true,
            //    handler(to) {
            //         this.$router.replace({ query: to }); // uncommend to debug
            //    }
            //},
            $route(to, from) {
                if (to.name != from.name) this.onSubmit(to.name);                           
            }
        },
        methods: {     
            getData(page = 0) {
                this.buildings.isLoading = true;
                axios.post("/umbraco/Surface/Buildings/GetBuildings", {                  
                    parent: this.parent,
                    size: this.size,
                    page: page,
                    filters: this.cleanFilters,
                    orderBy: this.orderBy
                }).then((response) => {                    
                    this.buildings.list = response.data.Items;
                    this.buildings.total = response.data.Total;                   
                    this.buildings.page = page;
                    this.sums.apartmentsCount = response.data.OtherProps['apartmentsCount'];
                    this.sums.buildingsCount = response.data.OtherProps['buildingsCount'];
                    this.buildings.isLoading = false;
                });
            },
            getNextPage() {      
                this.buildings.isLoading = true;
                axios.post("/umbraco/Surface/Buildings/GetBuildings", {                  
                    parent: this.parent,
                    size: this.size,
                    page: this.buildings.page + 1,
                    filters: this.cleanFilters,
                    orderBy: this.orderBy
                }).then((response) => {
                    if (response.data.Items && response.data.Items.length > 0) {
                        this.buildings.list = [...this.buildings.list, ...response.data.Items];
                        this.buildings.page++;
                    }                    
                    this.buildings.total = response.data.Total;                                      
                    this.sums.apartmentsCount = response.data.OtherProps['apartmentsCount'];
                    this.sums.buildingsCount = response.data.OtherProps['buildingsCount'];
                    this.buildings.isLoading = false;
                });
            },
            getPlacemarks() {
                this.placemarks.isLoading = true;
                axios.post("/umbraco/Surface/Buildings/GetPlacemarks", {                  
                    parent: this.parent,
                    filters: this.cleanFilters,
                    orderBy: this.orderBy
                }).then((response) => {
                    if (response.data && response.data.length > 0) {
                        this.placemarks.list = response.data;
                        this.placemarks.isLoading = false;
                    } else {
                        this.placemarks.list = [];
                        this.placemarks.isLoading = false;
                    }                  
                });
            },
            onSubmit(route) {
                this.$router.replace({ query: this.query })
                    .catch(() => {
                        // Just for navigation duplication error preventing
                    });
                switch (route) {
                    case 'map':
                        this.getPlacemarks();
                        break;
                    case 'grid':
                        this.getData(0);
                        break;
                }               
            },
            onReset() {
                this.filters.metro.splice(0);
                this.filters.districts.splice(0);
                this.filters.roomTypes.splice(0);
                this.filters.price = { minimum: null, maximum: null };
                this.filters.readinesses.splice(0);
                this.filters.square = { minimum: null, maximum: null };
                this.$set(this.orderBy, "title", "По-умолчанию");
                this.$set(this.orderBy, "property", "price");
                this.$set(this.orderBy, "type", "asc");                
                this.onSubmit(this.$router.currentRoute.name);
            },
            onMapsOpened() {
                if (!this.placemarks.isLoading) {
                    this.parseQueryString();
                    this.getPlacemarks();
                }              
            },
            onGridOpened() {
                if (!this.buildings.isLoading) {
                    this.parseQueryString();
                    this.getData(0);
                }               
            },
            parseQueryString() {
                let query = this.$router.currentRoute.query;
                let keys = Object.keys(query);
                if (keys.length) {
                    if (keys.includes('metro')) {
                        let metros = this.$children[0].$refs.metros.metro // ugly hack. Don't ever do it like that!
                        let queryMetros = Array.isArray(query.metro) ? query.metro : [query.metro];
                        let founded = metros.filter(item => queryMetros.indexOf(item.station) >= 0);
                        this.filters.metro.push(...founded);
                    }

                    if (keys.includes('districts')) {
                        this.filters.districts.push(...query.districts);
                    }

                    if (keys.includes('price')) {
                        this.filters.price = query.price;
                    }

                    if (keys.includes('square')) {
                        this.filters.square = query.square;
                    }

                    if (keys.includes('readinesses')) {
                        this.filters.readinesses.push(...query.readinesses.map(x => Number(x)));
                    }

                    if (keys.includes('roomTypes')) {
                        this.filters.roomTypes.push(...query.roomTypes);
                    }

                    if (keys.includes('orderBy')) {
                        this.$set(this.orderBy, "title", query.orderBy.title);
                        this.$set(this.orderBy, "property", query.orderBy.property);
                        this.$set(this.orderBy, "type", query.orderBy.type);
                    }
                }
            }
        },
        filters: {
            apartmentsCount,
            buildingsCount,
            threeDigits
        }
    }
</script>